import app from 'firebase/app';
import database from 'firebase/database';

import { firebaseConfig } from '../config/firebaseConfig.js';

app.initializeApp(firebaseConfig);

export const db = app.database();
